import React from "react";
import { Colors } from "../../utils/colors";
import { observer } from "mobx-react-lite";
import { usePaymentStore } from "../../stores/StoreContext";
import { DefaultCardNumber } from "./DefaultCardNumber";
import { DefaultCardExpiry } from "./DefaultCardExpiry";
import { RadioButton } from "../radioButton/RadioButton";
import { BookingPaymentType } from "../../utils/data";

type props = {};

export const DefaultPaymentCard: React.FC<props> = observer(() => {
  const paymentStore = usePaymentStore();
  return paymentStore.defaultPaymentCard ? (
    <div
      style={{
        border: `2px solid ${Colors.green}`,
        width: "100%",
        display: "flex",
        padding: "15px 20px",
        borderRadius: 20,
        marginBottom: 20,
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <div>
        <DefaultCardNumber
          cardNumber={paymentStore.defaultPaymentCard.displayName}
        />
        <DefaultCardExpiry
          expiryDate={paymentStore.defaultPaymentCard.validUntil}
        />
      </div>
      <RadioButton
        selected={
          paymentStore.selectedPaymentMethod === BookingPaymentType.CARD
        }
        onChange={() => {
          paymentStore.setSelectedPaymentMethod(BookingPaymentType.CARD);
        }}
      />
    </div>
  ) : null;
});
